import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

import { mediaDown, mediaUp } from '@/styles/media'

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

export const Wrapper = styled.section`
  position: relative;
  z-index: 1;
`

export const SearchWrapper = styled.div`
  background: linear-gradient(to bottom, #093769 50%, #fff 50%);

  max-height: 66px;
  position: relative;

  ${mediaUp('md')} {
    padding: 0 16px;
    background: linear-gradient(to bottom, #f2f6fd 50%, #fff 50%);
  }
  ${mediaUp('lg')} {
    padding: unset;
  }
`

export const ContainerForResults = styled.div`
  display: block;
  margin: 0 auto;
  justify-content: center;
  width: 340px;
  gap: 20px;
  margin-bottom: 32px;
  position: relative;
  top: 124px;

  ${mediaUp('md')} {
    display: grid;
    margin-top: 32px;
    max-width: 1440px;
    width: unset;
    grid-template-columns: 230px 3fr;
    padding: 0 16px;
    top: 0;
  }

  ${mediaUp('lg')} {
    top: 0;
    grid-template-columns: 1fr 3fr;
  }
`

export const StyledParkingCnt = styled.div`
  display: grid;
  gap: 6px;
  background: #fff;
  width: 320px;
  ${mediaUp('md')} {
    display: flex;
    width: unset;
    flex-direction: column;
  }

  ${mediaDown('md')} {
    margin-bottom: 120px;
  }
`

export const SortWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`

export const Stroker = styled.div`
  width: 1px;
  background-color: #c1c5c9;
  height: 36px;
`

export const Overlay = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  flex-direction: column;
  z-index: 2000;
  animation: ${({ isVisible }) => (isVisible ? fadeIn : fadeOut)} 0.3s linear;
`

export const OverlayContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
`

export const SpinnerOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`

export const Sorting = styled.div`
  width: 20.5vw;
  height: 8vh;
  margin-top: -10px;
  align-self: flex-end;
  justify-content: center;
  align-items: center;

  ${mediaDown('lg')} {
    height: 7.5vh;
    width: 30vw;
  }

  ${mediaDown('md')} {
    width: 100%;
    margin-top: 10px;
  }
`
